import { render, staticRenderFns } from "./VolumenTransacciones.vue?vue&type=template&id=71cc56fe&"
import script from "./VolumenTransacciones.vue?vue&type=script&lang=js&"
export * from "./VolumenTransacciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports